export const processSafeParseResponse = (ctx, response) => {
    if (response.success) {
        return;
    }
    const { error: { issues }, } = response;
    const [firstIssue] = issues;
    if (firstIssue) {
        ctx.addIssue(firstIssue);
    }
};
export const stripTags = (htmlString) => {
    const domParser = new DOMParser().parseFromString(htmlString, 'text/html');
    return domParser.body.textContent || '';
};
export const isEmptyHTMLText = (htmlString) => !stripTags(htmlString).trim();
